import { Link } from 'react-router';

import { PageHeader } from '../design/components';
import { useMistWebUrl } from './config';

export function NotFound() {
    const mistWeb = useMistWebUrl();
    return (
        <main className="sf-page">
            <PageHeader
                title="There’s nothing here"
                description={
                    <>
                        <Link to="/floor">Go to the floor</Link> or <Link to="/lead">the lead’s view</Link>
                        {mistWeb ? (
                            <>
                                , or <a href={mistWeb}>back to MIST</a>
                            </>
                        ) : null}
                        .
                    </>
                }
            />
        </main>
    );
}
